
import { PATH_CONSTANTS } from './pathConstants';

// Helper function to create a path with query parameters
export function createPath(path: string, params?: Record<string, string | number | undefined>): string {
  if (!params) return path;
  
  const queryParams = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join('&');
  
  return queryParams ? `${path}?${queryParams}` : path;
}

// Export all paths from pathConstants
export const PATHS = {
  ...PATH_CONSTANTS,
  
  // Helper function to create subscription pages with business id
  subscription: (businessId?: string) => createPath(PATH_CONSTANTS.ADMIN_SUBSCRIPTION, { business_id: businessId }),
  subscriptionSuccess: (businessId?: string) => createPath(PATH_CONSTANTS.ADMIN_SUBSCRIPTION_SUCCESS, { business_id: businessId }),
  subscriptionCancel: (businessId?: string) => createPath(PATH_CONSTANTS.ADMIN_SUBSCRIPTION_CANCEL, { business_id: businessId }),
};
